import { render } from "./PaymentFailedView.vue?vue&type=template&id=16a815f8"
import script from "./PaymentFailedView.vue?vue&type=script&lang=js"
export * from "./PaymentFailedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__